export default "__VITE_ASSET__hAg2irUb__"